import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import { QueryDropdown } from 'basic-components';
import { DropdownService } from 'primary-components';

import getApiConfig from 'api/ApiConfig';

import { useQueryClient } from '@tanstack/react-query';

const EMPTY_ARRAY = [];
const EMPTY_OBJ = {};
const GroupDropdown = ({ extraGroupQuery = undefined, groupName = undefined, groupRef = EMPTY_OBJ, name, onChange, menuPortalTarget = undefined, ...props }) => {
  const dispatch = useDispatch(),
        queryClient = useQueryClient(),
        getApiConfigLocal = useCallback(() => dispatch(getApiConfig()), [dispatch]),
        [groupQuery, setGroupQuery] = useState(),
        { fetchNextPage: fetchMoreGroups, isFetching: isFetchingGroups, isFetchingNextPage: isFetchingNextPageGroups, data: groups = EMPTY_ARRAY } = DropdownService.useQueryGroups({
          queryClient,
          input: groupQuery,
          getApiConfig: getApiConfigLocal,
          symbolsOnly: true,
          extraQuery: extraGroupQuery
        }),
        onChangeGroupName = useCallback(value => {
          if(value) {
            onChange({ groupName: value }, name)
          } else {
            onChange(undefined, name)
          }
        }, [name, onChange])

  return (
    <div className="data-science__pipeline-creator__body__options__resolver__bottom-row__symbol-filter__row">
      <QueryDropdown
          {...props}
          autoFocus
          defaultValue={groupName}
          fetchNextPage={fetchMoreGroups}
          isFetching={isFetchingGroups || isFetchingNextPageGroups}
          menuPlacement="bottom"
          menuPortalTarget={menuPortalTarget || document.body}
          name="groupName"
          noError
          onChange={onChangeGroupName}
          onInputChange={setGroupQuery}
          options={groups}
          placeholder="Choose group"
          ref={groupRef}
          required
      />
    </div>
  )
}

GroupDropdown.propTypes = {
  extraGroupQuery: PropTypes.string,
  groupName: PropTypes.string,
  groupRef: PropTypes.any,
  menuPortalTarget: PropTypes.any,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
}

export default GroupDropdown;